export default function () {
	document.addEventListener('DOMContentLoaded', () => {
		if (!window.matchMedia('(min-width: 1024px)').matches) return

		const sidebar = document.querySelector<HTMLDivElement>('.single-product-tabs-sidebar')

		if (!sidebar) {
			return
		}

		sidebar.addEventListener('click', (e: MouseEvent) => {
			const target = e.target as HTMLElement
			const item = target.closest<HTMLElement>('.single-product-tabs-sidebar-item')

			if (!item) {
				return
			}

			const tab = item.dataset.tab

			if (!tab) {
				return
			}

			const tabContent = document.querySelector<HTMLElement>(
				`.single-product-tabs-contents-item[data-tab="${tab}"]`,
			)

			if (!tabContent) {
				return
			}

			setTimeout(() => {
				tabContent.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				})
			}, 150)
		})
	})
}
